<!-- Main Content -->
<main class="mainContWrap">
    <!--slider-->
    <hp-slider></hp-slider>
    <!--category-->
    <hp-categories [urlWownet]="urlWownet"></hp-categories>
    <!--best-->
    <hp-best></hp-best>
    <!--brand-->
    <hp-brand></hp-brand>
    <!--recommend-->
    <hp-recommend></hp-recommend>
    <board-popup></board-popup>
</main>
